import {
  RULE_CHAIN_ITEMS_PER_PAGE,
  type SecuritySchemaMergedState,
} from 'components/SecuritySchema/model/SecuritySchemaModel';
import { pipe } from 'fp-ts/lib/function';
import { selectHighlightedRuleIndex } from './selectHighlightedRuleIndex';

export const selectHighlightedRuleOnCurrentPage = (
  state: SecuritySchemaMergedState,
): boolean =>
  pipe(
    state,
    selectHighlightedRuleIndex,
    (index) =>
      index !== null &&
      Math.floor(index / RULE_CHAIN_ITEMS_PER_PAGE) === state.page,
  );
